import { render } from "./edit-kios-modal.vue?vue&type=template&id=2ff5f262&scoped=true"
import script from "./edit-kios-modal.vue?vue&type=script&lang=js"
export * from "./edit-kios-modal.vue?vue&type=script&lang=js"

import "./edit-kios-modal.vue?vue&type=style&index=0&id=2ff5f262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff5f262"]])

export default __exports__